/*
  A wrapper for redux-form Field.
  Given a component is passed to Field.component, `props.input` is deconstructed into `props`
  http://redux-form.com/6.2.1/docs/api/Field.md/#props
*/

import React, { Component } from 'react';
import { Field as ReduxFormField } from 'redux-form';
import { StyledLabel, Paragraph, FlexBox } from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

const validateRequired = value => {
	return value ? undefined : 'Cannot be blank';
};

const Error = props => (
	<Paragraph
		color={theme.colors.tomato}
		fontSize={theme.fontSizes[3]}
		textAlign="right"
		margin="0"
	>
		{props.error}
	</Paragraph>
);

const renderField = FieldComponent => props => {
	const { input, style: styleProps, ...rest } = props;
	const styles = {
		...styleProps,
		...(props.meta.touched && props.meta.error ? { border: 'solid tomato 1px' } : {}),
	};

	return (
		<React.Fragment>
			<FieldComponent {...input} style={styles} {...rest} />
			{props.meta.touched && props.meta.error && <Error error={props.meta.error} />}
		</React.Fragment>
	);
};

const renderFieldWithLabel = FieldComponent => props => {
	const { input, style: styleProps, label, labelStyle, ...rest } = props;
	const styles = {
		...styleProps,
		...(props.meta.touched && props.meta.error ? { border: 'solid tomato 1px' } : {}),
	};

	return (
		<React.Fragment>
			<FlexBox alignItems="center" width="100%">
				{label && (
					<StyledLabel display="inline-block" marginRight="8px" {...labelStyle}>
						{label}
					</StyledLabel>
				)}
				<FieldComponent {...input} style={styles} {...rest} />
			</FlexBox>
			{props.meta.touched && props.meta.error && <Error error={props.meta.error} />}
		</React.Fragment>
	);
};

class FieldWrapper extends Component {
	constructor(props) {
		super(props);
		this.field = this.props.renderFunc(props.component);
	}

	render() {
		const { name, component, isRequired, ...rest } = this.props;
		// this.field has been set with the renderFunc already in the constructor, no need to keep it (+ it raises browser warnings)
		delete rest.renderFunc;
		const validate = isRequired ? validateRequired : null;
		return <ReduxFormField name={name} component={this.field} validate={validate} {...rest} />;
	}
}

const Field = props => <FieldWrapper {...props} renderFunc={renderField} />;
export const FieldWithLabel = props => (
	<FieldWrapper {...props} renderFunc={renderFieldWithLabel} />
);

export default Field;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/fields/Field.js